import React, { useState, useEffect } from 'react';
import styles from './index.module.sass';
import WATERMARK from '../../images/sign/terramar-letras-marca-de-agua.png';
import getAlmacenes from '../Queries/getAlmacenes.js';
import getPremios from '../Queries/getPremios.js';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Slide from '@mui/material/Slide';
import { useTranslation } from 'react-i18next';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='down' ref={ref} {...props} />;
});

export default function Warehouse({ history, webservice, setActualPage, getCookie, props }) {
  const [warehouse, setWarehouse] = useState([]);
  const [warehouseSelect, setwarehouseSelect] = useState(getCookie('warehouse'));
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);
  const [prize, setPrize] = useState(true);
  const { t } = useTranslation('warehouse');

  const changeValue = (e) => {
    setwarehouseSelect(e.target.value);
  };

  function selectWarehouse() {
    if (warehouseSelect === '') {
      setAlertText(t('alertContinue'));
      setOpen(true);
      return;
    } else {
      const now = new Date();
      const time = now.getTime();
      const expireTime = time + 1000 * 36000;
      now.setTime(expireTime);
      document.cookie = `warehouse=${warehouseSelect};expires=${now.toUTCString()};path=/`;
      document.cookie = `almacenSeleccionado=${warehouseSelect};expires=${now.toUTCString()};path=/`;

      async function estWarehouse() {
        const response = await getAlmacenes();
        setWarehouse(response.getAlmacenesResult.almacenes);
      }
      estWarehouse();

      history.push('/cart');
    }
  }

  useEffect(() => {
    async function loadWarehouse() {
      const response = await getAlmacenes();
      setWarehouse(response.getAlmacenesResult.almacenes);
    }
    loadWarehouse();

    async function havePrize() {
      const response = await getPremios();
      setPrize(response);
    }
    havePrize();
  }, [getCookie, webservice]);

  return (
    <form
      className={styles.formContainer}
      style={{
        backgroundImage: `url(${WATERMARK})`,
      }}>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setOpen(false)}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'>
        <DialogContent>
          <div className={styles.dialogContent}>
            <div className={styles.dialogTitle}>{t('alertTitle')}</div>
            {alertText}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <div className={styles.instructions}>
        <div className={styles.inputContainer}>
          <div className={styles.inputLabel}>{t('titleWarehouse')}</div>

          <select
            className={styles.inputSelect}
            onChange={(e) => changeValue(e)}
            value={warehouseSelect}>
            <option value=''>{t('changeWarehouse')}</option>
            {warehouse.map((val, key) => {
              return (
                <option key={key} value={val.almacen}>
                  {val.descri}
                </option>
              );
            })}
          </select>
        </div>
        <Button
          type='button'
          variant='contained'
          size='large'
          color='primary'
          className={styles.button}
          onClick={() => selectWarehouse()}>
          {t('selectWarehouse')}
        </Button>
        {prize ? (
          <div>
            <div className={styles.ad}>{t('notice')}</div>
            <div className={styles.ad2}>{t('message')}</div>
          </div>
        ) : (
          <div>&nbsp;</div>
        )}
      </div>
    </form>
  );
}
